import Image from 'next/image';
import type { VariantAttribute } from 'types/variant';

/** @deprecated */
export default function renderAttributeValue(
    value: string | number,
    attributes: Map<string, VariantAttribute[]>,
) {
    const variants = [...attributes];
    const variant = variants.find(([key]) => key === value)?.[1]?.[0];

    if (!variant) {
        return value;
    }

    return (
        <>
            {variant.swatch && (
                <Image
                    className="w-10 lg:w-12"
                    src={variant.swatch}
                    alt={variant.label}
                    width={48}
                    height={48}
                />
            )}
            <span className="ml-4 font-medium">{variant.label}</span>
        </>
    );
}
